import { useEffect, useState } from 'react';

export function useCatalogSectionNavigation(hasImages: boolean) {
  const [activeSection, setActiveSection] = useState('identity');
  useEffect(() => {
    const targetId = window.location.hash.slice(1);
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView();
      setActiveSection(targetId);
    }
    if (typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver((entries) => {
      const visibleSection = entries.find((entry) => entry.isIntersecting);
      if (visibleSection) setActiveSection(visibleSection.target.id);
    }, { rootMargin: '-130px 0px -55% 0px', threshold: 0 });
    const sectionIds = hasImages ? ['identity', 'classification', 'photos'] : ['identity', 'classification'];
    for (const id of sectionIds) {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    }
    return () => observer.disconnect();
  }, [hasImages]);
  return { activeSection, setActiveSection };
}
